/* eslint-disable import/prefer-default-export */

export const crossOrigin = {
    ANONYMOUS: 'anonymous',
    USE_CREDENTIALS: 'use-credentials',
};
